import React from 'react';

import type { RouteInfo } from '../models/RouteInfo';

export interface StackContextState {
  registerFmlPage: (page: HTMLElement, routeInfo: RouteInfo) => void;
  isInOutlet: () => boolean;
}

export const StackContext = React.createContext<StackContextState>({
  registerFmlPage: () => undefined,
  isInOutlet: () => false,
});
